module.exports = __webpack_public_path__ + "yz/media/owe.69e70e48.mp3";